import styled from 'styled-components';

export const DownloadableTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-family: 'Arial', sans-serif;
    font-size: 14px; /* Aumentado para mejor lectura en PDF */

    th, td {
        padding: 6px 8px;
        border: none;
        vertical-align: top;
    }

    thead {
        background-color: #f2f2f2;
    }

    tbody tr:nth-child(even) {
        background-color: #f9f9f9;
    }

    th.num, td.num {
        text-align: right;
        white-space: nowrap;
    }

    th.center, td.center {
        text-align: center;
        white-space: nowrap;
    }

    th.desc, td.desc {
        text-align: left;
        word-break: normal;
        overflow-wrap: anywhere;
    }

    /* Ajustes de anchos más cómodos */
    th:nth-child(1), td:nth-child(1) { width: 14%; } /* Ref. */
    th:nth-child(2), td:nth-child(2) { width: 40%; } /* Descripción */
    th:nth-child(3), td:nth-child(3) { width: 10%; } /* Cantidad */
    th:nth-child(4), td:nth-child(4) { width: 12%; } /* Precio Ud(s) */
    th:nth-child(5), td:nth-child(5) { width: 10%; } /* % IVA */
    th:nth-child(6), td:nth-child(6) { width: 8%; }  /* Dto (€) */
    th:nth-child(7), td:nth-child(7) { width: 8%; }  /* Total */
`;
